import { createReducer } from '@reduxjs/toolkit';

import {
  fetchPromoCodeStarted,
  fetchPromoCodeSucceeded,
  fetchPromoCodeFailed,
  removePromoCodeStarted,
  removePromoCodeSucceeded,
  removePromoCodeFailed,
  fetchRelatedProductsFailed,
  setRelatedProducts,
  setStep,
  fetchDocumentsFailed,
  setDocuments,
  setBooking,
  fetchHistoryStarted,
  fetchHistorySucceeded,
  fetchHistoryFailed,
  setHistory,
  updateBooking,
  replaceBooking,
} from '../../actions/booking';

export const initialState = {
  ...window.ecom.redux_initial_state.booking,
  step: 0,
  documents: [],
  api: { history: null },
};

const BookingReducer = createReducer(initialState, {
  [setBooking]: (state, action) => {
    state.current = action.payload;
  },
  [updateBooking]: (state, action) => {
    state.current = { ...state.current, ...action.payload };
  },
  [replaceBooking]: (state, action) => {
    state.current = action.payload;
  },
  [fetchPromoCodeStarted]: (state) => {
    state.promoCodeStatus = 'started';
    state.removePromoCodeStatus = undefined;
  },
  [fetchPromoCodeSucceeded]: (state) => {
    state.promoCodeStatus = 'succeeded';
  },
  [fetchPromoCodeFailed]: (state, action) => {
    state.promoCodeStatus = 'failed';
    state.promoError = action.payload;
  },
  [removePromoCodeStarted]: (state) => {
    state.promoCodeStatus = undefined;
    state.removePromoCodeStatus = 'started';
  },
  [removePromoCodeSucceeded]: (state) => {
    state.removePromoCodeStatus = 'succeeded';
  },
  [removePromoCodeFailed]: (state, action) => {
    state.removePromoCodeStatus = 'failed';
    state.promoError = action.payload;
  },
  [setRelatedProducts]: (state, action) => {
    state.relatedProducts = action.payload;
  },
  [fetchRelatedProductsFailed]: (state) => state,
  [setStep]: (state, action) => {
    state.step = action.payload;
  },
  [setDocuments]: (state, action) => {
    state.documents = action.payload;
  },
  [fetchDocumentsFailed]: (state) => state,
  [setHistory]: (state, action) => {
    state.history = action.payload;
  },
  [fetchHistoryFailed]: (state) => {
    state.api.history = 'failed';
  },
  [fetchHistoryStarted]: (state) => {
    state.api.history = 'started';
  },
  [fetchHistorySucceeded]: (state) => {
    state.api.history = 'succeeded';
  },
});

export default BookingReducer;
